const prefixApi = process.env.REACT_APP_BE_ROUTE;

export const prefixDefaultApi = prefixApi

export const prefixAuthApi = prefixApi.concat("login")
